import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import DefaultDenyButton from '@/game/prefabs/GeneralUI/Buttons/DefaultDenyButton';
import MinigameInstructionsController from '@/game/prefabs/Minigame/MinigameInstructionsController';

/* START OF COMPILED CODE */

export default class MinigameInstructions extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// backingPanel
		const backingPanel = scene.add.nineslice(0, 24, "Hud3", undefined, 160, 96, 12, 12, 12, 12);
		backingPanel.scaleX = 4;
		backingPanel.scaleY = 4;
		desktopView.add(backingPanel);

		// startMinigameButton
		const startMinigameButton = new DefaultButton(scene, -104, 168);
		desktopView.add(startMinigameButton);

		// returnToWorldButton
		const returnToWorldButton = new DefaultDenyButton(scene, 104, 168);
		desktopView.add(returnToWorldButton);

		// gameDescription
		const gameDescription = scene.add.bitmapText(0, 0, "Aronui", "<Listen to the sound and choose the letter, or letters, we use to write that sound.>");
		gameDescription.setOrigin(0.5, 0.5);
		gameDescription.tintTopLeft = 5387071;
		gameDescription.tintTopRight = 5387071;
		gameDescription.tintBottomLeft = 5387071;
		gameDescription.tintBottomRight = 5387071;
		gameDescription.text = "<Listen to the sound and choose the letter, or letters, we use to write that sound.>";
		gameDescription.fontSize = -22;
		gameDescription.maxWidth = 400;
		desktopView.add(gameDescription);

		// headerContainer
		const headerContainer = scene.add.container(0, -164);
		desktopView.add(headerContainer);

		// headerBacking
		const headerBacking = scene.add.nineslice(0, 0, "Header1", undefined, 96, 24, 8, 8, 8, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		headerContainer.add(headerBacking);

		// gameTitleText
		const gameTitleText = scene.add.bitmapText(0, 0, "Aronui", "<GAME TITLE>");
		gameTitleText.setOrigin(0.5, 0.5);
		gameTitleText.tintTopLeft = 3023407;
		gameTitleText.tintTopRight = 3023407;
		gameTitleText.tintBottomLeft = 3023407;
		gameTitleText.tintBottomRight = 3023407;
		gameTitleText.text = "<GAME TITLE>";
		gameTitleText.fontSize = -32;
		headerContainer.add(gameTitleText);

		// image_1
		const image_1 = scene.add.image(-160, -20, "diamonds-1");
		image_1.scaleX = 4;
		image_1.scaleY = 4;
		headerContainer.add(image_1);

		// image
		const image = scene.add.image(160, 20, "diamonds-2");
		image.scaleX = 4;
		image.scaleY = 4;
		headerContainer.add(image);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// backingPanel_m
		const backingPanel_m = scene.add.nineslice(0, 0, "Hud1", undefined, 200, 120, 10, 10, 10, 10);
		backingPanel_m.scaleX = 3;
		backingPanel_m.scaleY = 3;
		mobileView.add(backingPanel_m);

		// startMinigameButton_m
		const startMinigameButton_m = new DefaultButton(scene, -80, 132);
		startMinigameButton_m.scaleX = 0.75;
		startMinigameButton_m.scaleY = 0.75;
		mobileView.add(startMinigameButton_m);

		// returnToWorldButton_m
		const returnToWorldButton_m = new DefaultDenyButton(scene, 80, 132);
		returnToWorldButton_m.scaleX = 0.75;
		returnToWorldButton_m.scaleY = 0.75;
		mobileView.add(returnToWorldButton_m);

		// gameDescription_m
		const gameDescription_m = scene.add.bitmapText(0, 0, "Aronui", "<Listen to the sound and choose the letter, or letters, we use to write that sound.>");
		gameDescription_m.setOrigin(0.5, 0.5);
		gameDescription_m.tintTopLeft = 5387071;
		gameDescription_m.tintTopRight = 5387071;
		gameDescription_m.tintBottomLeft = 5387071;
		gameDescription_m.tintBottomRight = 5387071;
		gameDescription_m.text = "<Listen to the sound and choose the letter, or letters, we use to write that sound.>";
		gameDescription_m.fontSize = -22;
		gameDescription_m.maxWidth = 400;
		mobileView.add(gameDescription_m);

		// headerContainer_m
		const headerContainer_m = scene.add.container(0, -144);
		mobileView.add(headerContainer_m);

		// headerBacking_m
		const headerBacking_m = scene.add.nineslice(0, -3, "Header1", undefined, 120, 26, 8, 8, 8, 8);
		headerBacking_m.scaleX = 3;
		headerBacking_m.scaleY = 3;
		headerContainer_m.add(headerBacking_m);

		// gameTitleText_m
		const gameTitleText_m = scene.add.bitmapText(0, 0, "Aronui", "<GAME TITLE>");
		gameTitleText_m.setOrigin(0.5, 0.5);
		gameTitleText_m.tintTopLeft = 3023407;
		gameTitleText_m.tintTopRight = 3023407;
		gameTitleText_m.tintBottomLeft = 3023407;
		gameTitleText_m.tintBottomRight = 3023407;
		gameTitleText_m.text = "<GAME TITLE>";
		gameTitleText_m.fontSize = -32;
		headerContainer_m.add(gameTitleText_m);

		// image_2
		const image_2 = scene.add.image(-153, -15, "diamonds-1");
		image_2.scaleX = 3;
		image_2.scaleY = 3;
		headerContainer_m.add(image_2);

		// image_3
		const image_3 = scene.add.image(153, 9, "diamonds-2");
		image_3.scaleX = 3;
		image_3.scaleY = 3;
		headerContainer_m.add(image_3);

		// startMinigameButton (prefab fields)
		startMinigameButton.buttonText = "Begin";

		// returnToWorldButton (prefab fields)
		returnToWorldButton.buttonText = "Return To World";

		// startMinigameButton_m (prefab fields)
		startMinigameButton_m.buttonText = "Begin";

		// returnToWorldButton_m (prefab fields)
		returnToWorldButton_m.buttonText = "Return To World";

		this.startMinigameButton = startMinigameButton;
		this.returnToWorldButton = returnToWorldButton;
		this.gameDescription = gameDescription;
		this.gameTitleText = gameTitleText;
		this.desktopView = desktopView;
		this.startMinigameButton_m = startMinigameButton_m;
		this.returnToWorldButton_m = returnToWorldButton_m;
		this.gameDescription_m = gameDescription_m;
		this.gameTitleText_m = gameTitleText_m;
		this.mobileView = mobileView;

		/* START-USER-CTR-CODE */
    this._controller = new MinigameInstructionsController(this);
    /* END-USER-CTR-CODE */
	}

	public startMinigameButton: DefaultButton;
	public returnToWorldButton: DefaultDenyButton;
	public gameDescription: Phaser.GameObjects.BitmapText;
	public gameTitleText: Phaser.GameObjects.BitmapText;
	public desktopView: Phaser.GameObjects.Container;
	public startMinigameButton_m: DefaultButton;
	public returnToWorldButton_m: DefaultDenyButton;
	public gameDescription_m: Phaser.GameObjects.BitmapText;
	public gameTitleText_m: Phaser.GameObjects.BitmapText;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  _controller: MinigameInstructionsController;
  get controller() {
    return this._controller;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
